import Form from "../../form";
import Model from "../../../model/model";

import { pst } from "../../../http/api";
import { ask } from '../../../utils/popups';





export default Form.extend( {

    template: 'jst/auth.set.password.form',

    events: {

        'keyup [type=password]'(/* e */) {
            const $pw = this.$( '[name=password]' );
            const $pwc = this.$( '[name=password_confirmation]' );
            this.$el.closest( '.modal' ).find( '.action-accept' )
                [0]
                .disabled = !$pw.val().length || $pw.val() !== $pwc.val();
        },

    }

}, {

    popup({ token }) {
        const Class = this;
        const binding = new Class().bind( new Model( {
            'password': '',
            'password_confirmation': ''
        } ) );
        
        return ask( binding, 
            'auth::label - set new password', 'actions::apply', 'actions::cancel',
            {
                afterRender(_, firstTime) {
                    if (firstTime)
                        this.$( '.action-accept' )[0].disabled = true;
                }
            },
            form => pst( `/auth/password-restore/set-new-password/${token}?apiVersion=2.0` ).cerebellum()
                .body( { password: form.model.get( 'password' ) } )
                .execute()
                .catch( resp => Form.handleHttpError( form, resp ) ) );
    },

} );



// WEBPACK FOOTER //
// ./src/js/view/module/auth/set.password.form.js